const colLinks = {
  '快速入口': [
    { label: '今日热榜', href: '#trending' },
    { label: '最新爆料', href: '#feed' },
    { label: '今日速递', href: '#timeline' },
    { label: '吃瓜问答', href: '#faq' },
    { label: '关于瓜田', href: '#about' },
  ],
  '内容分类': [
    { label: '影视剧综', href: '#feed' },
    { label: '综艺现场', href: '#feed' },
    { label: '音乐舞台', href: '#feed' },
    { label: '品牌商业', href: '#feed' },
    { label: '圈内趣闻', href: '#feed' },
  ],
};

export default function Footer() {
  return (
    <footer id="contact" className="w-full bg-accent-100/60">
      {/* 投稿横幅 */}
      <div className="border-b border-accent-200/70 bg-gradient-to-r from-accent-500 to-accent-600">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 px-4 py-8 text-center md:flex-row md:px-6 md:text-left">
          <div>
            <h2 className="font-heading text-2xl text-accent-950 md:text-3xl">有瓜？说来听听！</h2>
            <p className="mt-1 text-sm text-accent-900">把你在全网刷到的圈内新鲜事投稿给我们，一经核实即刻上版。</p>
          </div>
          <div className="flex flex-col gap-2 sm:flex-row">
            <a
              href="mailto:guatian@example.com"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-6 py-3 text-sm font-semibold text-accent-700 transition hover:bg-background-100"
            >
              <i className="ri-send-plane-line" aria-hidden="true" />
              guatian@example.com
            </a>
            <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-accent-400/50 px-5 py-3 text-sm font-medium text-accent-950">
              <i className="ri-time-line" aria-hidden="true" /> 编辑部 7×12 在线盯瓜
            </span>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-6xl px-4 py-10 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="瓜田网回到顶部">
              <span className="flex h-9 w-9 items-center justify-center rounded-2xl bg-primary-500 text-lg leading-none">🍉</span>
              <span className="font-heading text-xl text-primary-700">瓜田网</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              今日新瓜速递 · 最新爆料合集 · 热门大瓜汇总，每日实时更新。做一个有温度、有底线的吃瓜阵地，
              让你不错过任何精彩动态。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {[
                ['ri-weibo-line', '微博'],
                ['ri-wechat-2-line', '微信公众号'],
                ['ri-bilibili-line', 'B站'],
                ['ri-douban-line', '豆瓣'],
              ].map(([ic, label]) => (
                <a
                  key={label}
                  href="#top"
                  aria-label={label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50 text-foreground-700 transition hover:bg-primary-500 hover:text-background-50"
                >
                  <i className={`${ic} text-lg`} aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(colLinks).map(([title, links]) => (
            <nav key={title} className="md:col-span-3" aria-label={title}>
              <h3 className="text-sm font-semibold text-foreground-950">{title}</h3>
              <ul className="mt-4 space-y-2.5">
                {links.map((l) => (
                  <li key={l.label}>
                    <a href={l.href} className="text-sm text-foreground-600 transition hover:text-primary-700">
                      {l.label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-1">
            <h3 className="text-sm font-semibold text-foreground-950">随时吃瓜</h3>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              收藏本页，明天同一个入口，新瓜准时上新。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-3 border-t border-accent-200/70 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 瓜田网 · 娱乐动态资讯聚合门户</p>
          <p className="flex items-center gap-2">
            <i className="ri-shield-check-line text-accent-600" aria-hidden="true" />
            理性吃瓜 · 内容仅作资讯观察，请勿据此对个人作出判断
          </p>
        </div>
      </div>
    </footer>
  );
}